import { render, staticRenderFns } from "./moduleAssigned.vue?vue&type=template&id=73b1144a"
import script from "./moduleAssigned.vue?vue&type=script&lang=js"
export * from "./moduleAssigned.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports